import backend, {CLIENT_API, SCHEDULE_API} from 'utils/backend/server/api_library';

import queryString from 'query-string';

const createClient = (input) => {
  const url = `${CLIENT_API}/client`;
  return backend.post(url, input);
};

const getClient = (clientRn, loadLatestAnnouncementMessage, loadCareview, loadCareplan, loadForms, loadCallStatus, loadOwner) => {
  const queryParam = {
    loadLatestAnnouncementMessage,
    loadCareview,
    loadCareplan,
    loadCallStatus,
    loadForms,
    loadCallStatus,
    loadOwner,
  };
  const query = queryString.stringify(queryParam, {skipNull: true, skipEmptyString: true});

  const url = `${CLIENT_API}/client/${clientRn}?${query}`;
  return backend.get(url);
};

const queryClient = (filters, sort, lastEvaluatedKey) => {
  const queryParam = {
    lastEvaluatedKey: lastEvaluatedKey,
  };
  if (filters) {
    queryParam.filters = JSON.stringify(filters);
  }
  if (sort) {
    queryParam.sort = JSON.stringify(sort);
  }

  const query = queryString.stringify(queryParam, {skipNull: true, skipEmptyString: true});
  const url = `${CLIENT_API}/client?${query}`;
  return backend.get(url);
};

const updateDescription = (clientRn, body) => {
  const url = `${CLIENT_API}/client/${clientRn}/detail/description`;
  return backend.put(url, body);
};

const updateFile = (clientRn, body) => {
  const url = `${CLIENT_API}/client/${clientRn}/detail/profile_image`;
  return backend.put(url, body);
};

const updateStatus = (clientRn, body) => {
  const url = `${CLIENT_API}/client/${clientRn}/detail/status`;
  return backend.put(url, body);
};

const updateName = (clientRn, body) => {
  const url = `${CLIENT_API}/client/${clientRn}/detail/name`;
  return backend.put(url, body);
};

const editClientOwner = (clientRn, body) => {
  const url = `${CLIENT_API}/client/${clientRn}/detail/owner`;
  return backend.put(url, body);
};

const editCallStatus = (clientRn, body) => {
  const url = `${CLIENT_API}/client/${clientRn}/call_status`;
  return backend.put(url, body);
};

const addContact = (clientRn, body) => {
  const url = `${CLIENT_API}/client/${clientRn}/detail/contact`;
  return backend.post(url, body);
};

const removeContact = (clientRn, body) => {
  const url = `${CLIENT_API}/client/${clientRn}/detail/contact`;
  return backend.delete(url, body);
};

const addCaregiver = (clientRn, body) => {
  const url = `${CLIENT_API}/client/${clientRn}/detail/caregiver`;
  return backend.post(url, body);
};

const removeCaregiver = (clientRn, body) => {
  const url = `${CLIENT_API}/client/${clientRn}/detail/caregiver`;
  return backend.delete(url, body);
};

const addRelationship = (clientRn, body) => {
  const url = `${CLIENT_API}/client/${clientRn}/detail/relationship`;
  return backend.post(url, body);
};

const editRelationship = (clientRn, relationshipRn, body) => {
  const url = `${CLIENT_API}/client/${clientRn}/detail/relationship/${relationshipRn}`;
  return backend.put(url, body);
};

const removeRelationship = (clientRn, relationshipRn) => {
  const url = `${CLIENT_API}/client/${clientRn}/detail/relationship/${relationshipRn}`;
  return backend.delete(url);
};

const createMessage = (clientRn, input) => {
  const url = `${CLIENT_API}/client/${clientRn}/message`;
  return backend.post(url, input);
};

const updateMessage = (clientRn, messageRn, input) => {
  const url = `${CLIENT_API}/client/${clientRn}/message/${messageRn}`;
  return backend.put(url, input);
};

const addEmoji = (clientRn, messageRn, input) => {
  const url = `${CLIENT_API}/client/${clientRn}/message/${messageRn}/emoji`;
  return backend.put(url, input);
};

const removeEmoji = (clientRn, messageRn, input) => {
  const url = `${CLIENT_API}/client/${clientRn}/message/${messageRn}/emoji`;
  return backend.delete(url, input);
};

const removeMessage = (clientRn, messageRn) => {
  const url = `${CLIENT_API}/client/${clientRn}/message/${messageRn}`;
  return backend.delete(url);
};

const loadMoreMessages = (clientRn, lastKey, loadSubmittedByData, loadEmojiRequesters) => {
  const queryParam = {
    lastEvaluatedKey: lastKey,
    loadSubmittedByData,
    loadEmojiRequesters,
  };

  const query = queryString.stringify(queryParam, {
    skipNull: true,
    skipEmptyString: true,
    encode: true,
  });

  return backend.get(`${CLIENT_API}/client/${clientRn}/message?${query}`);
};

const loadLogs = (clientRn, lastEvaluatedKey, loadRequesterData) => {
  const queryParam = {
    lastEvaluatedKey,
    loadRequesterData,
  };

  const query = queryString.stringify(queryParam, {
    skipNull: true,
    skipEmptyString: true,
    encode: true,
  });

  return backend.get(`${CLIENT_API}/client/${clientRn}/log?${query}`);
};

const loadScheduleByMonth = (clientRn, byMonths, loadCaregiverUpdates) => {
  const body = {
    byMonths,
    loadCaregiverUpdates,
  };
  return backend.post(`${SCHEDULE_API}/schedule/client/${clientRn}`, body);
};

const loadScheduleByIsoRange = (clientRn, start, end, loadCaregiverUpdates) => {
  const body = {
    isoRange: {
      start,
      end,
    },
    loadCaregiverUpdates,
  };

  return backend.post(`${SCHEDULE_API}/schedule/client/${clientRn}`, body);
};

const addEvent = (clientRn, body) => {
  return backend.post(`${SCHEDULE_API}/schedule/client/${clientRn}/fixed`, body);
};

const deactivateEvent = (clientRn, eventRn, body) => {
  return backend.delete(`${SCHEDULE_API}/schedule/client/${clientRn}/fixed/${eventRn}`, body);
};

const addRecurrence = (clientRn, body) => {
  return backend.post(`${SCHEDULE_API}/schedule/client/${clientRn}/recurrence`, body);
};

const deactivateRecurrence = (clientRn, recurrenceRn, body) => {
  return backend.delete(`${SCHEDULE_API}/schedule/client/${clientRn}/recurrence/${recurrenceRn}`, body);
};

const cancelExceptionRecurrence = (clientRn, recurrenceRn, body) => {
  return backend.post(`${SCHEDULE_API}/schedule/client/${clientRn}/recurrence/${recurrenceRn}/exception/cancellation`, body);
};

const addLiveIn = (clientRn, body) => {
  return backend.post(`${SCHEDULE_API}/schedule/client/${clientRn}/live_in`, body);
};

const deactivateLiveIn = (clientRn, liveInRn, body) => {
  return backend.delete(`${SCHEDULE_API}/schedule/client/${clientRn}/live_in/${liveInRn}`, body);
};

const cancelExceptionLiveIn = (clientRn, liveInRn, body) => {
  return backend.post(`${SCHEDULE_API}/schedule/client/${clientRn}/live_in/${liveInRn}/exception/cancellation`, body);
};

const careviewAddQuestion = (clientRn, type, questionData) => {
  const body = {
    type,
    questionData,
  };

  return backend.post(`${CLIENT_API}/client/${clientRn}/careview/question`, body);
};

const careviewUpdateQuestion = (clientRn, questionRn, questionData) => {
  const body = {
    questionData,
  };

  return backend.put(`${CLIENT_API}/client/${clientRn}/careview/question/${questionRn}`, body);
};

const careviewDeleteQuestion = (clientRn, questionRn) => {
  return backend.delete(`${CLIENT_API}/client/${clientRn}/careview/question/${questionRn}`);
};

const careviewReorderQuestion = (clientRn, reorderList) => {
  const body = {
    reorderList,
  };
  return backend.post(`${CLIENT_API}/client/${clientRn}/careview/question/reorder`, body);
};

const careviewResetQuestions = (clientRn) => {
  return backend.post(`${CLIENT_API}/client/${clientRn}/careview/question/reset`);
};

const updateCareplan = (clientRn, body) => {
  return backend.put(`${CLIENT_API}/client/${clientRn}/careplan`, body);
};

const updateLeadQuality = (clientRn, body) => {
  return backend.put(`${CLIENT_API}/client/${clientRn}/careplan/lead_quality`, body);
};

export default {
  createClient,
  getClient,
  queryClient,

  updateDescription,
  updateStatus,
  updateFile,
  updateName,
  editClientOwner,
  editCallStatus,
  addContact,
  removeContact,
  addCaregiver,
  removeCaregiver,

  relationship: {
    add: addRelationship,
    edit: editRelationship,
    remove: removeRelationship,
  },

  message: {
    create: createMessage,
    update: updateMessage,
    delete: removeMessage,
    load: loadMoreMessages,

    emoji: {
      add: addEmoji,
      remove: removeEmoji,
    },
  },

  loadLogs,

  schedule: {
    loadByMonth: loadScheduleByMonth,
    loadByIsoRange: loadScheduleByIsoRange,
    addEvent,
    deactivateEvent,
    addRecurrence,
    deactivateRecurrence,
    cancelExceptionRecurrence,
    addLiveIn,
    deactivateLiveIn,
    cancelExceptionLiveIn,
  },

  careview: {
    addQuestion: careviewAddQuestion,
    updateQuestion: careviewUpdateQuestion,
    deleteQuestion: careviewDeleteQuestion,
    reorderQuestion: careviewReorderQuestion,
    resetQuestions: careviewResetQuestions,
  },

  updateCareplan,
  updateLeadQuality,
};
